<template>
  <BaseDialog
    v-model="showDialog"
    :title="title"
    :subtitle="subtitle"
    :dialogIcon="icon"
    btnActionName="Lagre"
    @action="save"
  >
    <template v-slot>
      <v-form ref="form" v-model="valid">
        <v-textarea
          v-model="getData.comment"
          filled
          :label="label"
        ></v-textarea>
      </v-form>

      <div class="mb-4">
        <v-chip
          v-model="getData.complete"
          class="elevation-2"
          active-class="activeColor"
          filter
          :ripple="false"
          :disabled="!!getData.completedBy"
          @click="getData.complete = !getData.complete"
        >
          {{
            getData.complete
              ? !!getData.completedBy
                ? "Ok"
                : "Fjern Ok"
              : "Sett Ok"
          }}
        </v-chip>
      </div>

      <v-btn
        v-if="getData.attachments && getData.attachments.length > 0"
        class="mb-2"
        small
        color="primary"
        @click="$refs.dropzone.addAttachment()"
      >
        Legg til fil
      </v-btn>
      <FileDropzone v-model="getData.attachments" ref="dropzone" />
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import FileDropzone from "@/components/shared/attachments/FileDropzone.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    icon: {
      type: String,
    },
    label: {
      type: String,
    },
  },
  data() {
    return {
      valid: false,
    };
  },
  methods: {
    async save() {
      const isValid = (this as any).$refs?.form?.validate();
      if (isValid) {
        this.$emit("save", this.getData);
      }
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    getData: {
      get(): string {
        return this.data;
      },
      set(value: string) {
        this.$emit("data", value);
      },
    },
  },
  components: {
    BaseDialog,
    FileDropzone,
  },
});
</script>

<style lang="scss" scoped>
.activeColor {
  color: var(--v-iconOnPrimary-base);
  background-color: var(--v-primary-base);
}
</style>
